import { defineComponent, ref, computed, PropType, toRefs } from '@vue/composition-api';
import { Message } from 'byted-vui';
import {
  useStore,
  useHandleAuditRejectAppealV2Api,
  useHandleAuditRejectAppealRealLiveApi,
  useAuditInfo
} from '@tt4b/ttam-hooks';

import { i18n } from './../../../../i18n';
import { RejectInfo } from '@tt4b/ttam-enums';
import AuditRejectAppealDialog from './audit-reject-appeal-dialog.vue';
import { trackEvent } from './../../../../utils/index';
import { createLogger } from '@tt4b/ttam-utils';

const name = 'ttam-audit-reject-appeal';
const logger = createLogger('oneClickAppeal');

export default defineComponent({
  name,
  components: {
    AuditRejectAppealDialog,
  },
  props: {
    adgroupId: {
      type: String,
      default: '',
    },
    creativeId: {
      type: String,
      default: '',
    },
    objectiveType: {
      type: Number,
    },
    promotionFlowType: {
      type: Number,
    },
    rejectInfo: {
      type: Object as PropType<RejectInfo>,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const { rejectInfo, isEdit } = toRefs(props);
    const { state } = useStore();
    const aadvid = computed(() => state.baseInfo.value?.aadvid);
    const { isNotAppeal, isAppealDone, isAppealing, isAppealFail, isMultipleCountries, isLiveRoomOpen, isRealLiveAds } =
      useAuditInfo({
        rejectInfo,
      });
    const isShowAppealBtn = computed(
      () => isNotAppeal.value || isAppealDone.value || (isRealLiveAds.value && isAppealing.value)
    );
    const isRealLiveAppealBtnDisabled = computed(() => {
      const appealBtnEnabled = isNotAppeal.value && isLiveRoomOpen.value;
      return isRealLiveAds.value && !appealBtnEnabled;
    });
    const appealBtnDisabled = computed(
      () => isAppealing.value || isAppealDone.value || isRealLiveAppealBtnDisabled.value
    );
    const appealTooltipDisabled = computed(() => !isEdit.value && isNotAppeal.value);
    const appealTooltipContent = computed(() => {
      if (isRealLiveAds.value && isAppealing.value) {
        return i18n.t('common_appeal_btn_disabled_hint');
      }
      if (isRealLiveAds.value && !isLiveRoomOpen.value && isNotAppeal.value) {
        return i18n.t('module_ad_group_live_has_stop');
      }
      if (isAppealDone.value) {
        return i18n.t('common_appeal_btn_disabled_hint');
      }
      return i18n.t('common_appeal_btn_hint');
    });
    const showAppealDialog = ref(false);

    // 埋点通用参数
    const eventParams = computed(() => ({
      eventInfo: {
        ad_id: props.adgroupId,
        creative_id: props.creativeId,
        aadvid: aadvid.value,
        isEdit: true,
        is_real_Live: isRealLiveAds.value,
        objective_type: props.objectiveType,
        promotion_flow_type: props.promotionFlowType,
        appeal_btn_disabled: appealBtnDisabled.value,
      },
    }));

    const handleAppealDialogClose = () => {
      showAppealDialog.value = false;
      trackEvent('appeal_reason_cancel', eventParams.value);
    };
    /**
     * 直投直播间一键申诉提交
     */
    const handleRealLiveAppealSubmit = () => {
      const params: Record<string, unknown> = {
        ad_id: props.adgroupId,
        aadvid: aadvid.value,
      };
      useHandleAuditRejectAppealRealLiveApi(params)
        .then(data => {
          trackEvent('appeal_btn_click_success', eventParams.value);
          logger.info('one click appeal in real-time live ads successfully', {
            ...eventParams.value,
          });
          emit('appeal-complete');
          Message.success(i18n.t('module_reject_appeal_success_info') as string);
        })
        .catch(e => {
          trackEvent('appeal_btn_click_fail', eventParams.value);
          logger.error('one click appeal in real-time live ads fail', e);
        });
    };
    const handleAppealBtnClick = () => {
      trackEvent('appeal_btn_click', eventParams.value);
      if (isRealLiveAds.value) {
        handleRealLiveAppealSubmit();
        return;
      }
      showAppealDialog.value = true;
    };
    /**
     * 一键申诉提交
     */
    const handleAppealReasonsSubmit = (appealFormData = {}) => {
      const params: Record<string, unknown> = {
        ad_id: props.adgroupId,
        aadvid: aadvid.value,
        ...appealFormData,
      };
      // creative申诉加入creative_id
      if (props.creativeId) {
        params.creative_id = props.creativeId;
      }

      useHandleAuditRejectAppealV2Api(params)
        .then(data => {
          console.log('data', data);
          trackEvent('appeal_btn_click_success', eventParams.value);
          logger.info('one click appeal in non-real-time live ads successfully', {
            ...eventParams.value,
          });
          emit('appeal-complete');
          Message.success(i18n.t('module_reject_appeal_success_info') as string);
        })
        .catch(e => {
          trackEvent('appeal_btn_click_fail', eventParams.value);
          logger.error('one click appeal in non-real-time live ads fail', e);
        });

      trackEvent('appeal_reason_submit', {
        eventInfo: {
          ...params,
          isEdit: true,
        },
      });
    };

    console.log(isNotAppeal.value, isAppealDone.value);

    return {
      name,
      isNotAppeal,
      isAppealDone,
      isAppealing,
      isAppealFail,
      showAppealDialog,
      isMultipleCountries,
      isLiveRoomOpen,
      isRealLiveAds,
      appealBtnDisabled,
      appealTooltipDisabled,
      appealTooltipContent,
      isShowAppealBtn,

      handleAppealDialogClose,
      handleAppealReasonsSubmit,
      handleAppealBtnClick,
    };
  },
});
